import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { CODE_SYSTEM, S3_URL } from "../services/Constants";
import { componentIsVisible, validateAndSanitizeUrl } from "../util/common";
import {
  fetchCodeSetTable,
  getTableId,
  updateCodeSetTable,
} from "../services/referenceTable-service";
import { useContext } from "react";
import UserContext from "../context/user-context";
import { CSNANVB, CSNDB } from "../util/component-codes";
import { Alert } from "@mui/material";
const initialRows = [
  {
    reference_table_id: null,
    reference_code: "",
    reference_Code_description: "",
  },
];
const PicklistValueConfigurations = () => {
  const [form, setForm] = useState({});
  const [valueSet, setValueSet] = useState("");
  const [rows, setRows] = useState(JSON.parse(JSON.stringify(initialRows)));
  const [user] = useContext(UserContext);
  const [tableId, setTableId] = useState(0);

  const addUpdateValueSet = () => {
    let copy = [...rows];
    let newArray = { ...initialRows[0] };
    copy.push(newArray);
    setRows(copy);
  };

  const updateReferenceTableValuesRows = (copyRows) => {
    let form = {
      referenceTableId: tableId,
      referenceTableName: valueSet,
      refTableValues: copyRows,
    };
    updateCodeSetTable(tableId, form);
  };

  const removeRow = (index) => {
    let copyRows = [...rows];
    copyRows.splice(index, 1);
    setRows(copyRows);
    updateReferenceTableValuesRows(copyRows);
  };

  const updateRows = (index, value) => {
    if (rows.some((item) => item.reference_code === value)) {
      let copyRows = [...rows];
      let X = copyRows[index];

      X["reference_code"] = value;
      X["reference_Code_description"] = "";
      setRows(copyRows);
    } else {
      let copyRows = [...rows];
      let X = copyRows[index];

      X["reference_code"] = value;
      X["reference_Code_description"] = value;
      setRows(copyRows);
      
      if (X["reference_code"] !== "") {
        updateReferenceTableValuesRows(copyRows);
      }
    }
  };

  const setFormField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });
  };

  const handleValueSetChange = async (value) => {
    setValueSet(value);
    if (value !== "") {
      let response = await fetchCodeSetTable(value);
      if (response.ok) {
        let data = await response.json();
        setRows(data?.refTableValues);
        setTableId(data.referenceTableId ? data.referenceTableId : 0);
      } else {
        setRows();
      }
    }
  };

  const handleDropdownChange = (event, value) => {
    setFormField("field", event.target.value);
    handleValueSetChange(event.target.value);
  };

  return (
    <>
      <Container fluid className="loincContainer">
        <Row style={{ marginLeft: "0px" }}>
          <Col xl={8}>
            <Row className="tableTitle generalFont">
              Picklist Value Configuration
            </Row>
            <Row className="tableSubtitle generalFont">
              View and Update Existing Picklist Values on Data Tables
            </Row>
          </Col>
        </Row>

        <Row style={{ marginLeft: "0px" }}>
          <Col xl={12} style={{ paddingLeft: "0px" }}>
            <div
              style={{
                background: "white",
                minHeight: "80px",
                display: "flex",
                alignItems: "center",
                maxWidth: "95%",
              }}
            >
              <Col sm={3} style={{ paddingLeft: "10px", paddingTop: "15px" }}>
                <Form.Group className="mb-3" controlId="form.DataTable">
                  <Form.Select
                    className="modalInput generalFont"
                    aria-label="Choose Item"
                    onChange={(e) => setFormField("DataTable", e.target.value)}
                  >
                    <option value="">Choose Data Table</option>
                    <option value="LOINC">LOINC</option>
                  </Form.Select>
                </Form.Group>{" "}
                <Form.Group className="mb-3" controlId="form.Field">
                  <Form.Select
                    className="modalInput generalFont"
                    aria-label="Choose Item"
                    onChange={handleDropdownChange}
                    disabled={form.DataTable == null || form.DataTable === ""}
                  >
                    <option value="">Choose Field</option>
                    <option value="Test Method">Test Method</option>
                    <option value="Property">Property</option>
                    <option value="Code System">Code System</option>
                    <option value="Time Aspect">Time Aspect</option>
                    <option value="Scale Type">Scale Type</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </div>
          </Col>
        </Row>
        <br />
        {form.field != undefined && form.field !== "" && (
          <>
            {rows &&
              rows.map((row, index) => {
                return (
                  <div key={index}>
                    <Row>
                      <Col>
                        <Form.Control
                          className="modalInput generalFont"
                          type="text"
                          required
                          value={row.reference_code}
                          readOnly={row.reference_Code_system_version != null}
                          onChange={(e) => updateRows(index, e.target.value)}
                        />
                      </Col>
                      <Col xs={1}>
                        {componentIsVisible(CSNDB, user) &&
                          row.reference_Code_system_version == null && (
                            <Button
                              onClick={(event) => removeRow(index)}
                              className="removeButtonStylegreybackground generalFont flexCenter "
                            >
                              <img
                                src={`${validateAndSanitizeUrl(
                                  S3_URL
                                )}delete-icon.png`}
                                className="buttonIcon"
                                alt=""
                              ></img>
                            </Button>
                          )}
                      </Col>
                      <Col>
                        {row?.reference_Code_description === "" && (
                          <Alert severity="error">
                            Either the value is empty or duplicate and would not be saved!
                          </Alert>
                        )}
                      </Col>
                      <Col></Col>
                      <Col></Col>
                    </Row>
                    <br />
                  </div>
                );
              })}
            {rows && componentIsVisible(CSNANVB, user) && (
              <Button
                className="modalAddUpdateStyle generalFont flexCenter"
                onClick={() => addUpdateValueSet()}
              >
                Add New Value
              </Button>
            )}
          </>
        )}
      </Container>
    </>
  );
};

export default PicklistValueConfigurations;
